<template>
  <v-card :loading="loading" class="col-12 mx-auto">
    <QrScanner 
              :showTuts="showTuts" 
              @decode="handleQrCodeData" 
              @clear-input="filters.search = ''" 
              @update:showTuts="val => showTuts = val" 
       />

    <!-- NFC Free Modal -->
    <custom-popup
      v-model="showNfcFreeModal"
      :cons="{
        title:
          nfcConditionView === 'list'
            ? 'لیست شرط‌های NFC رایگان'
            : nfcFreeData?.isEdit
            ? 'ویرایش شرط'
            : 'افزودن شرط جدید',
        icon: 'card',
      }"
      max-width="800"
      class="nfc-free-popup"
      hide-confirm
      :reloadable="true"
      :persistent="true"
      @reload="fetchNfcConditions"
    >
      <v-card class="rounded-0" outlined flat>
        <div v-if="nfcConditionView === 'list'" class="pa-4">
          <v-alert type="info" dense border="left" colored-border class="mb-3">
            شرایط جدید به صورت خودکار اضافه می‌شوند.
          </v-alert>
          <v-divider class="mb-4" />

          <!-- جدول لیست شرط‌ها -->
          <vue-table
            :data="conditionsTableData"
            :headers="conditionHeaders"
            :loading="conditionsLoading"
            :props.sync="conditionsTableProps"
            @change="fetchNfcConditions"
          >
            <template v-slot:row_number="{ item }">
              {{
                conditionsTableData.data.findIndex((x) => x.id === item.id) + 1
              }}
            </template>

            <!-- اسلات وضعیت رایگان -->
            <template v-slot:free_permission="{ item }">
              <v-chip
                :color="item?.free_permission == 1 ? 'success' : 'error'"
                small
              >
                {{
                  item?.free_permission == 1 ? "رایگان" : " طرح رایگان ندارد"
                }}
              </v-chip>
            </template>
            <template v-slot:min_days="{ item }">
              {{ item.min_days || 350 }}
            </template>
            <template v-slot:updated_at="{ item }">
              {{ jalalian(item.updated_at) }}
            </template>
            <template v-slot:type="{ item }">
              <v-icon left small color="primary">{{
                getQrIcon(item.type)
              }}</v-icon>
              {{ getQrName(item.type) }}
            </template>
            <template v-slot:actions="{ item }">
              <manageButton2
                :data="item"
                :meta="metaButtons"
                v-if="ribbon_can('nfc_edit_state_solo')"
                :limit="3"
              />
              <span v-else>-</span>
            </template>
          </vue-table>
        </div>

        <!-- حالت دوم: فرم افزودن / ویرایش -->
        <v-form v-else ref="nfcFreeForm" v-model="nfcFreeFormValid">
          <div class="pa-4 d-flex justify-end">
            <v-btn
              class="btn-delete rounded-lg"
              @click="nfcConditionView = 'list'"
              >بازگشت به لیست
              <v-icon right>mdi-arrow-left</v-icon>
            </v-btn>
          </div>
          <v-card-text class="pa-6 pt-0">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-if="nfcFreeData?.isEdit"
                  :value="getQrName(nfcFreeData.type)"
                  label="نوع کیوآرکد"
                  outlined
                  dense
                  readonly
                >
                  <template v-slot:prepend-inner>
                  <v-badge
                    v-if="['visitcardpro','clickyarseo'].includes(nfcFreeData?.type?.trim()?.toLowerCase())"
                    color="transparent"
                    overlap
                    offset-x="23"
                    offset-y="10"
                  >
                    <template #badge>
                      <v-icon left x-small color="primary" class="ml-2">mdi-crown</v-icon>
                    </template>
                    <v-icon left small color="primary" class="ml-2">{{ getQrIcon(nfcFreeData.type) }}</v-icon>
                  </v-badge>
                  <v-icon v-else left small color="primary" class="ml-2">{{getQrIcon(nfcFreeData.type) }}</v-icon>
                  </template>
                </v-text-field>
                <v-autocomplete
                  v-else
                  v-model="nfcFreeData.type"
                  :items="apiQrTypesList"
                  item-text="name"
                  item-value="value"
                  label="نوع کیوآرکد"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'انتخاب نوع کیوآرکد الزامی است']"
                >
                  <template v-slot:selection="{ item }">
                    <v-icon left small color="primary" class="ml-2">{{
                      getQrIcon(item.value)
                    }}</v-icon>
                    <span>{{ getQrName(item.value) }}</span>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon left small color="primary" class="ml-2">{{
                      getQrIcon(item.value)
                    }}</v-icon>
                    <span>{{ getQrName(item.value) }}</span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="nfcFreeData.free_permission"
                  :items="[
                    { text: 'دارای طرح رایگان', value: 1 },
                    { text: 'فاقد طرح رایگان', value: 0 },
                  ]"
                  label="دسترسی رایگان"
                  outlined
                  dense
                  :rules="[(v) => v !== null || 'انتخاب الزامی است']"
                />
              </v-col>

              <v-col v-if="nfcFreeData.free_permission === 1" cols="12" md="6">
                <v-text-field
                  v-model.number="nfcFreeData.min_days"
                  label="تعداد روز"
                  type="number"
                  outlined
                  min="350"
                  dense
                  placeholder="حداقل 350 روز"
                  :rules="[
                    (v) => v >= 350 || 'تعداد روز باید بیشتر از 350 باشد',
                  ]"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pa-4 d-flex justify-space-between border-top">
            <v-btn
              class="btn-delete rounded-lg"
              @click="nfcConditionView = 'list'"
            >
              <v-icon left small>mdi-close</v-icon>
              انصراف
            </v-btn>
            <v-btn
              class="btn-get-code rounded-lg"
              :loading="saving"
              :disabled="!nfcFreeFormValid"
              @click="saveNFCFree"
            >
              <v-icon left small>mdi-content-save-all</v-icon>
              ثبت تنظیمات
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </custom-popup>
    <!-- Edit Modal -->
    <custom-popup
      v-model="showEditModal"
      :cons="{ title: 'ویرایش کارت NFC' }"
      max-width="700"
      class="edit-nfc-popup"
      hide-confirm
    >
      <v-card class="rounded-0" outlined flat>
        <v-form ref="editForm" v-model="formValid">
          <v-card-text class="pa-6">
            <!-- Image Preview at Top -->
            <v-row class="mb-6" justify="center">
              <v-col cols="12" class="text-center">
                <p class="text-subtitle-2 mb-2">تصاویر کارت:</p>
                <div class="d-flex justify-center gap-4 flex-wrap">
                  <div v-if="editItem.front_image" class="text-center">
                    <p class="text-caption mb-2">تصویر جلو</p>
                    <img
                      :src="editItem.front_image"
                      alt="Front"
                      class="edit-preview-img rounded-lg elevation-4"
                      eager
                    />
                  </div>
                  <div v-if="editItem.back_image" class="text-center">
                    <p class="text-caption mb-2">تصویر پشت</p>
                    <img
                      :src="editItem.back_image"
                      alt="Back"
                      class="edit-preview-img rounded-lg elevation-4"
                      eager
                    />
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-divider class="mb-4" />

            <!-- Form Fields -->
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editItem.title"
                  label="عنوان"
                  outlined
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <price-input
                  v-model.number="editItem.price"
                  label="قیمت (ریال)"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="editItem.discount"
                  label="تخفیف (درصد)"
                  type="number"
                  outlined
                  dense
                  :rules="[(v) => (v >= 0 && v <= 100) || 'تخفیف بین 0 تا 100']"
                  append-icon="mdi-percent"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="editItem.orientation"
                  :items="orientationItems"
                  label="جهت کارت"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editItem.color"
                  label="رنگ"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="editItem.status"
                  :items="statusItemsForEdit"
                  label="وضعیت"
                  outlined
                  :disabled="editItem.status === 'assigned'"
                  dense
                  :hint="
                    editItem.status === 'assigned'
                      ? 'وضعیت اختصاص داده شده قابل تغییر نیست'
                      : ''
                  "
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editItem.short_link"
                  label="لینک کوتاه"
                  outlined
                  dense
                  readonly
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editItem.tags"
                  label="برچسب‌ها"
                  outlined
                  dense
                  clearable
                  hint="برچسب‌ها را با کاما جدا کنید"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editItem.front_image"
                  label="لینک تصویر جلو"
                  outlined
                  dense
                  type="url"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editItem.back_image"
                  label="لینک تصویر پشت"
                  outlined
                  dense
                  type="url"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-switch
                  :true-value="1"
                  :false-value="0"
                  v-model="editItem.is_free"
                  :label="editItem.is_free === 1 ? 'رایگان' : 'غیر رایگان'"
                  color="primary"
                  dense
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pa-4 d-flex justify-space-between">
            <!-- <v-spacer /> -->
            <v-btn class="btn-delete rounded-lg" @click="showEditModal = false">
              <v-icon left small>mdi-close</v-icon>
              انصراف
            </v-btn>
            <v-btn
              class="btn-get-code rounded-lg"
              :loading="saving"
              :disabled="!formValid"
              @click="saveChanges"
            >
              <v-icon left small>mdi-content-save</v-icon>
              ذخیره تغییرات
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </custom-popup>

    <!-- Mass Update Modal -->
    <custom-popup
      v-model="showMassUpdateModal"
      :cons="{ title: 'تغییر وضعیت گروهی کارت‌های NFC' }"
      max-width="600"
      class="mass-update-popup"
      hide-confirm
    >
      <v-row
        class="mb-6"
        justify="center"
        v-if="massUpdateData.front_image || massUpdateData.back_image"
      >
        <v-col cols="12" class="text-center">
          <p class="text-subtitle-2 mb-2">تصاویر کارت:</p>
          <div class="d-flex justify-center gap-4 flex-wrap">
            <div v-if="massUpdateData.front_image" class="text-center">
              <p class="text-caption mb-2">تصویر جلو</p>
              <img
                :src="massUpdateData.front_image"
                alt="Front"
                class="edit-preview-img rounded-lg elevation-4"
                eager
              />
            </div>
            <div v-if="massUpdateData.back_image" class="text-center">
              <p class="text-caption mb-2">تصویر پشت</p>
              <img
                :src="massUpdateData.back_image"
                alt="Back"
                class="edit-preview-img rounded-lg elevation-4"
                eager
              />
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-4" />
      <v-card class="rounded-0" outlined flat>
        <v-form ref="massUpdateForm" v-model="massUpdateFormValid">
          <v-card-text class="pa-6">
            <!-- Selected Items Info -->
            <v-alert type="info" colored-border border="left" class="mb-4">
              <div class="d-flex align-center">
                <span>
                  شناسه کارت‌ها را وارد کنید و وضعیت جدید را انتخاب نمایید
                </span>
              </div>
            </v-alert>

            <v-divider class="mb-4" />

            <!-- Mass Update Fields -->
            <v-row>
              <v-row align="center">
                <v-col cols="12" md="12">
                  <v-switch
                    v-model="massUpdateToggles.title"
                    label="ویرایش عنوان"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="12" v-if="massUpdateToggles.title">
                  <v-text-field
                    v-model="bulkRenewalTitle"
                    label="عنوان تمدید گروهی"
                    outlined
                    dense
                    :disabled="!massUpdateToggles.title"
                    :rules="
                      massUpdateToggles.title ? [(v) => !!v || 'اجباری'] : []
                    "
                  />
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="nfcIdsInput"
                  label="شناسه کارت‌ها"
                  placeholder="شناسه کارت‌ها را با کاما یا خط جدید وارد کنید (مثال: 1,2,3 یا هر کدام در یک خط)"
                  outlined
                  rows="5"
                  :rules="[(v) => !!v || 'لطفا شناسه کارت‌ها را وارد کنید']"
                  hint="می‌توانید شناسه‌ها را با کاما (،) یا در خطوط جداگانه وارد کنید"
                  persistent-hint
                  @blur="checkCommonValuesForBulk"
                />
              </v-col>

              <v-col cols="12">
                <v-select
                  v-model="massUpdateData.status"
                  :items="statusItemsForMass"
                  label="وضعیت"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'لطفا وضعیت را انتخاب کنید']"
                />
              </v-col>

              <v-col cols="12">
                <v-select
                  v-model="massUpdateData.is_free"
                  :items="freeItems"
                  label="وضعیت رایگان"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6" v-if="massUpdateData.is_free === 0">
                <price-input
                  v-model.number="massUpdateData.price"
                  label="قیمت (ریال)"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" md="6" v-if="massUpdateData.is_free === 0">
                <v-text-field
                  v-model.number="massUpdateData.discount"
                  label="تخفیف (درصد)"
                  type="number"
                  outlined
                  max="100"
                  min="0"
                  dense
                  :rules="[
                    (v) =>
                      v == null ||
                      (v >= 0 && v <= 100) ||
                      'تخفیف باید بین 0 تا 100 باشد',
                  ]"
                  append-icon="mdi-percent"
                />
              </v-col>
              <v-row align="center">
                <v-col cols="12" md="12">
                  <v-switch
                    v-model="massUpdateToggles.image"
                    label="ویرایش تصاویر کارت"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="12" v-if="massUpdateToggles.image">
                  <v-text-field
                    v-model="massUpdateData.front_image"
                    label="لینک تصویر جلو"
                    outlined
                    dense
                    type="url"
                  />
                </v-col>
                <v-col cols="12" md="12" v-if="massUpdateToggles.image">
                  <v-text-field
                    v-model="massUpdateData.back_image"
                    label="لینک تصویر پشت"
                    outlined
                    dense
                    type="url"
                  />
                </v-col>
                <v-col cols="12" md="12" v-if="massUpdateToggles.image">
                  <v-select
                    v-model="massUpdateData.orientation"
                    :items="orientationItemsMass"
                    label="جهت کارت"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" md="12">
                  <v-switch
                    v-model="massUpdateToggles.color"
                    label="ویرایش رنگ"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="12" v-if="massUpdateToggles.color">
                  <v-text-field
                    v-model="massUpdateData.color"
                    label="رنگ"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </v-row>

            <v-alert
              v-if="parsedIds.length > 0"
              type="success"
              colored-border
              border="left"
              class="mt-4"
            >
              <div class="d-flex align-center">
                <span>
                  <strong>{{ parsedIds.length }}</strong> شناسه معتبر وارد شده
                  است
                </span>
              </div>
            </v-alert>

            <v-alert type="warning" colored-border border="left" class="mt-4">
              <div class="d-flex align-center">
                <span>
                  توجه: وضعیت تمام کارت‌های وارد شده به وضعیت انتخاب شده تغییر
                  خواهد یافت.
                </span>
              </div>
            </v-alert>
          </v-card-text>

          <v-card-actions class="pa-4 d-flex justify-space-between">
            <!-- <v-spacer /> -->
            <v-btn class="btn-delete rounded-lg" @click="closeMassUpdate">
              <v-icon left small>mdi-close</v-icon>
              انصراف
            </v-btn>
            <v-btn
              class="btn-get-code rounded-lg"
              :loading="saving"
              :disabled="!massUpdateFormValid || parsedIds.length === 0"
              @click="saveMassUpdate"
            >
              <v-icon left small>mdi-content-save-all</v-icon>
              اعمال تغییرات روی {{ parsedIds.length }} کارت
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </custom-popup>
    <BulkQrCreate v-model="bulkQr" />
    <!-- Toolbar with Mass Update Button -->
    <v-card-text class="pa-4">
      
<div class="d-flex flex-wrap justify-center justify-md-space-between mb-4 w-100">
  <NfcManagerRW 
  :nfcRW.sync="nfcRW" 
  :initialUrl="selectedShort_link" 
  @update-search="handleNfcSearch" 
  :tab.sync="currentNfcTab" 

/>
  <v-btn 
    class="btn-download rounded-lg"  
    :block="$vuetify.breakpoint.xsOnly"
    @click="showTuts = true"
    v-if="!$vuetify.breakpoint.mdAndUp"
  >
    <v-icon class="mx-2">mdi-camera</v-icon>
    اسکنر هوشمند 
  </v-btn>
  <v-btn
    class="btn-buy rounded-lg"
    :block="$vuetify.breakpoint.xsOnly"
    @click="openNfcRW"
  >
    <v-icon left>mdi-card</v-icon>
    nfc خواندن/ نوشتن 
  </v-btn>  
  <v-btn
    class="btn-upload rounded-lg"
    :block="$vuetify.breakpoint.xsOnly"
    @click="openNFCFreeModal"
    v-if="ribbon_can('nfc_free_permission')"
  >
    <v-icon left>mdi-card</v-icon>
    nfc رایگان
  </v-btn>

  <v-btn
    :block="$vuetify.breakpoint.xsOnly"
    class="btn-get-code rounded-lg"
    @click="bulkQr = true"
    v-if="ribbon_can('nfc_qr_bulk_creation')"
  >
    <v-icon left>mdi-plus</v-icon>
    ساخت گروهی کیوآر با فایل اکسل
  </v-btn>
  <v-spacer class="d-none d-md-block" />
    <v-btn
    :block="$vuetify.breakpoint.xsOnly"
      :class="downloadUrl === null ? 'btn-get-code rounded-lg' : 'btn-download rounded-lg'"
      v-if="selectedIds.length > 0 && ribbon_can('nfc_add_reserve_qr_code') && $vuetify.breakpoint.xsOnly"
      @click="openGeneratorPopup"
    >
      <template v-if="downloadUrl">
        <v-icon right>mdi-download</v-icon>
        دانلود
      </template>
      <template v-else>
        <v-icon right>mdi-qrcode</v-icon>
        ساخت کیوارکد ({{ selectedIds.length }})
      </template>
    </v-btn>

    <v-btn 
      class="btn-upload rounded-lg"
      @click="openMassUpdateModal"
      :block="$vuetify.breakpoint.smAndDown"
      v-if="ribbon_can('nfc_edit_state_bulk') && $vuetify.breakpoint.xsOnly"
    >
      <v-icon left>mdi-pencil-box-multiple</v-icon>
      تغییر وضعیت گروهی
    </v-btn>

  <div class="d-flex gap-3 align-center flex-wrap justify-center" v-if="!$vuetify.breakpoint.xsOnly">
    <v-btn
    :block="$vuetify.breakpoint.xsOnly"
      :class="downloadUrl === null ? 'btn-get-code rounded-lg' : 'btn-download rounded-lg'"
      v-if="selectedIds.length > 0 && ribbon_can('nfc_add_reserve_qr_code')"
      @click="openGeneratorPopup"
    >
      <template v-if="downloadUrl">
        <v-icon right>mdi-download</v-icon>
        دانلود
      </template>
      <template v-else>
        <v-icon right>mdi-qrcode</v-icon>
        ساخت کیوارکد ({{ selectedIds.length }})
      </template>
    </v-btn>
    <v-btn
      class="btn-upload rounded-lg"
      @click="openMassUpdateModal"
      :block="$vuetify.breakpoint.smAndDown"
      v-if="ribbon_can('nfc_edit_state_bulk')"
    >
      <v-icon left>mdi-pencil-box-multiple</v-icon>
      تغییر وضعیت گروهی
    </v-btn>
  </div>
</div>
    <MassQrDesignPopup v-model="showGeneratorModal" :selected-ids="selectedIds" />

    </v-card-text>
    <!-- ================= بخش چرخه خودکار اسکن و رایت ================= -->
<v-card outlined class="mb-4 pa-3" style="background-color: rgba(255,255,255,0.05); border-color: var(--v-success-base) !important;">
  <v-switch
    v-model="isAutoCycleActive"
    label="فعال‌سازی چرخه خودکار (اسکن QR/ رایت NFC/ساخت QR/اتصال NFC)"
    color="success"
    hide-details
    class="mt-0 font-weight-bold"
    @change="toggleAutoCycle"
  ></v-switch>
  
  <v-expand-transition>
    <div v-if="isAutoCycleActive || successList.length > 0" class="mt-4">
      <div class="d-flex justify-space-between align-center mb-2">
        <span class="text-subtitle-2 success--text">کارت‌های موفق: {{ successList.length }} عدد</span>
        <div>
          <v-btn small class="btn-get-code rounded-lg mr-2" @click="copySuccessList">
            <v-icon left small>mdi-content-copy</v-icon> کپی
          </v-btn>
          <v-btn small class="btn-delete rounded-lg" @click="clearSuccessList" :disabled="successList.length === 0">
            <v-icon left small>mdi-delete</v-icon> پاک کردن
          </v-btn>
        </div>
      </div>
      <v-textarea
        :value="successList.join('\n')"
        readonly
        outlined
        dense
        rows="3"
        hide-details
        dir="ltr"
        placeholder="لیست شناسه‌های موفق اینجا نمایش داده می‌شود..."
      ></v-textarea>
    </div>
  </v-expand-transition>
</v-card>
<!-- ================= پایان بخش چرخه خودکار ================= -->

    <div
      class="d-flex align-center justify-start"
      style="gap: 1px; white-space: nowrap"
    >
      <v-checkbox
        :input-value="isAllSelected"
        @change="toggleSelectAll"
        hide-details
        class="ma-0 pa-0 mr-4"
      ></v-checkbox>
      <span class="mr-2">انتخاب همه</span>
    </div>
    <mixed-table
      ref="myTable"
      :data="data"
      :columns="columns"
      :fetch-data="getData"
      :reload-table="reloadTable"
      @on-table-props-changed="onTablePropsChanged"
      :tb-props="filters"
    >
      <template #filters>
        <v-row no-gutters class="mb-4 align-center px-4">
          <v-col class="pa-2" cols="12" lg="2" md="2">
            <v-select
              v-model="filters.length"
              :items="perPageOptions"
              class="rounded-lg"
              dense
              hide-details
              label="تعداد"
              outlined
              @change="onFilterChange"
            />
          </v-col>
          <!-- فیلتر جهت مرتب‌سازی -->
          <v-col class="pa-2" cols="12" lg="2" md="2" sm="12">
            <v-autocomplete
              v-model="filters.dir"
              class="rounded-lg"
              clearable
              :items="dirItems"
              item-text="text"
              item-value="value"
              dense
              hide-details
              label="جهت مرتب سازی"
              outlined
              @change="onFilterChange"
            >
              <template v-slot:selection="{ item }">
                <v-icon left small> {{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
              <template v-slot:item="{ item }">
                <v-icon left small> {{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- فیلتر نوع -->
          <v-col class="pa-2" cols="12" lg="2" md="2" sm="12">
            <v-autocomplete
              v-model="filters.is_free"
              class="rounded-lg"
              clearable
              :items="typeItems"
              item-text="text"
              item-value="value"
              dense
              hide-details
              label="نوع"
              outlined
              @change="onFilterChange"
            >
              <template v-slot:selection="{ item }">
                <v-icon left small> {{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
              <template v-slot:item="{ item }">
                <v-icon left small> {{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- فیلتر وضعیت -->
          <v-col class="pa-2" cols="12" lg="2" md="2" sm="12">
            <v-autocomplete
              v-model="filters.status"
              append-icon="mdi-list-status"
              class="rounded-lg"
              clearable
              :items="statusItems"
              item-text="text"
              item-value="value"
              dense
              hide-details
              label="وضعیت"
              outlined
              @change="onFilterChange"
            >
              <template v-slot:selection="{ item }">
                <v-icon left small color="primary">{{ item.icon }}</v-icon>
                {{ item.text }}
              </template>
              <template v-slot:item="{ item }">
                <v-icon left small color="primary">{{ item.icon }}</v-icon>
                {{ item.text }}
              </template>
            </v-autocomplete>
          </v-col>

          <!-- فیلتر جستجو -->
          <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
            <v-text-field
              v-model="filters.search"
              append-icon="mdi-magnify"
              class="rounded-lg"
              clearable
              dense
              hide-details
              label="جستجو..."
              outlined
              @keyup.enter="onSearchInput" 
              @click:append="onSearchInput"
            >
              <template v-slot:prepend-inner v-if="$vuetify.breakpoint.mdAndUp">
                <!-- دکمه اسکنر کیوآرکد -->
                <v-btn 
                  icon 
                  small 
                  class="ml-1"
                  @click.stop.prevent="showTuts = true" 
                  @mousedown.stop 
                >
                  <v-icon color="primary">mdi-camera</v-icon>
                </v-btn>
        </template>
            </v-text-field>
          </v-col>

        </v-row>
      </template>
    </mixed-table>
    <v-menu
      v-if="ribbon_can('nfc_edit_state_bulk')"
      v-model="statusMenu.show"
      :position-x="statusMenu.x"
      :position-y="statusMenu.y"
      absolute
      offset-y
    >
      <v-list dense>
        <v-list-item
          v-if="currentItemStatus !== 'available'"
          @click="toggleNfcStatus(statusMenu.id, 'available')"
        >
          <v-list-item-icon>
            <v-icon color="teal">mdi-check-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>موجود</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="currentItemStatus !== 'unavailable'"
          @click="toggleNfcStatus(statusMenu.id, 'unavailable')"
        >
          <v-list-item-icon>
            <v-icon color="red">mdi-close-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>ناموجود</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="currentItemStatus !== 'complete'"
          @click="toggleNfcStatus(statusMenu.id, 'complete')"
        >
          <v-list-item-icon>
            <v-icon color="blue">mdi-check-all</v-icon>
          </v-list-item-icon>
          <v-list-item-title>آماده شده</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
<NfcAutoAssigner 
  ref="assignerComponent"
  @success="onAssignSuccess"
  @error="onAssignError"
/>  </v-card>
</template>

<script>
import MixedTable from "@/view/components/Table/MixedTable.vue";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import { debounce } from "@/main";
import manageButton from "@/view/pages/button_solo";
import manageButton2 from "@/view/pages/button";
import priceInput from "@/view/pages/uiBeautifier/priceInput";
import MassQrDesignPopup from "./MassQrDesignPopup.vue";
import BulkQrCreate from "./BulkQrCreate.vue";
import QrScanner from "./QrScanner.vue";
import Vuetify from "vuetify/lib";
import NfcManagerRW from "./NfcManagerRW.vue";
import { io } from "socket.io-client";
import { initNfcService } from "../../../../../src/assets/js/components/nfcService.js"
import NfcAutoAssigner from "./NfcAutoAssigner.vue";

export default {
  name: "NfcCartList",
  components: {
    MixedTable,
    CustomPopup,
    manageButton,
    manageButton2,
    priceInput,
    MassQrDesignPopup,
    BulkQrCreate,
    QrScanner,
    NfcManagerRW,
    NfcAutoAssigner
  },
  data() {
    return {
      currentNfcTab: 0, 
      isAutoCycleActive: false,
      scannerDialog: false,
      duplicateCardsList: [],
      pendingWriteItem: null, 
      successList: [],
      currentWritingId: null,
      socket: null,
      nfcRW:false,
      showTuts:false,
      bulkQr: false,
      searchTimeout: null,
      showGeneratorModal: false,
      massUpdateToggles: {
        title: false,
        image: false,
        color: false,
      },
      downloadUrl: null,
      options: {
        different_borders_color: false,
        different_eyes_color: false,
        marker_out_color: "#000000",
        marker_in_color: "#000000",
        dotsOptions: { type: "extra-rounded", color: "#000000" },
        cornersSquareOptions: { type: "extra-rounded", color: "#000000" },
        cornersDotOptions: { type: "", color: "#000000" },
        qrOptions: { errorCorrectionLevel: "H" },
      },
      bulkOptions: {
        transparent: "on",
      },
      designObject_patttern: [],
      designObject_square: [],
      designObject_dots: [],
      selectedIds: [],
      bulkRenewalTitle: "کارت nfc",
 metaButtons: {
        buttons: [
          {
            name: "edit",
            label: "ویرایش",
            icon: "edit",
            class: "btn-edit border-2 rounded-pill",
            action: this.editCondition,
            status: "phoneBook_show",
          },
          {
            name: "delete",
            label: "حذف",
            icon: "trash",
            class: "btn-outline-danger border-2 rounded-pill",
            action: this.deleteCondition,
            status: "phoneBook_show",
          },
        ],
      },
      nfcConditionView: "list", // 'list' یا 'form'
      apiQrTypesList: [],
      conditionsTableData: {
        data: [],
        current_page: 1,
        last_page: 1,
        total: 0,
      },
      conditionsLoading: false,
      conditionsTableProps: { page: 1, length: 100 },
      conditionHeaders: [
        { text: "ردیف", value: "row_number", sortable: false },
        { text: "نوع", value: "type" },
        { text: "تعداد روز", value: "min_days" },
        { text: "دسترسی", value: "free_permission" },
        { text: "آخرین به روزسانی", value: "updated_at" },
        { text: "مدیریت", value: "actions", sortable: false },
      ],
      nfcFreeData: {
        isEdit: false,
        id: null,
        type: null,
        free_permission: 1,
        min_days: 350,
      },
      showNfcFreeModal: false,
      nfcFreeFormValid: false,
      qrTypesList: [],
      statusMenu: {
        show: false,
        x: 0,
        y: 0,
        id: null,
      },
      showStatusDropdown: false,
      statusMenuModal: false,
      selectedIdForStatus: null,
      filters: {
        search: "",
        length: 10,
        column: "id",
        dir: "asc",
        page: 1,
        status: null,
        type: null,
        is_free: null,
      },
      perPageOptions: [10, 25, 50, 100, 200, 500, 1000],
      statusItems: [
        { text: "همه", value: null, icon: "mdi-all-inclusive" },
        { text: "آماده شده", value: "complete", icon: "mdi-check-all" },
        {
          text: "اختصاص داده شده",
          value: "assigned",
          icon: "mdi-account-check",
        },
        { text: "موجود", value: "available", icon: "mdi-check-circle" },
        { text: "ناموجود", value: "unavailable", icon: "mdi-close-circle" },
      ],

      typeItems: [
        { text: "همه", value: null, icon: "mdi-all-inclusive" },
        { text: "رایگان", value: "1", icon: "mdi-gift" },
        { text: "غیر رایگان", value: "0", icon: "mdi-cash" },
      ],
      statusItemsForEdit: [
        { text: "آماده شده", value: "complete" },
        { text: "موجود", value: "available" },
        { text: "ناموجود", value: "unavailable" },
      ],
      statusItemsForMass: [
        { text: "آماده شده", value: "complete" },
        { text: "موجود", value: "available" },
        { text: "ناموجود", value: "unavailable" },
      ],

      dirItems: [
        { text: "صعودی", value: "asc", icon: "mdi-sort-ascending" },
        { text: "نزولی", value: "desc", icon: "mdi-sort-descending" },
      ],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "asc",
        page: 1,
        is_free: null,
        status: null,
      },
      loading: false,
      saving: false,
      showEditModal: false,
      showMassUpdateModal: false,
      formValid: false,
      massUpdateFormValid: false,
      nfcIdsInput: "",
      editItem: {
        id: null,
        title: null,
        price: 0,
        discount: 0,
        tags: null,
        front_image: null,
        back_image: null,
        orientation: "vertical",
        color: null,
        status: "unavailable",
        short_link: null,
        is_free: 0,
      },
      massUpdateData: {
        status: "unavailable",
        is_free: null,
        price: null,
        discount: null,
        front_image: null,
        back_image: null,
        orientation: "vertical",
        color: null,
      },
      data: {},
      orientationItemsMass: [
        { text: "بدون تغییر", value: null },
        { text: "عمودی", value: "vertical" },
        { text: "افقی", value: "horizontal" },
      ],
      orientationItems: [
        { text: "عمودی", value: "vertical" },
        { text: "افقی", value: "horizontal" },
      ],
      freeItems: [
        { text: "بدون تغییر", value: null },
        { text: "رایگان", value: 1 },
        { text: "با هزینه", value: 0 },
      ],
      columns: [
        {
          label: "انتخاب",
          name: "select",
          orderable: false,
          transform: (val) => {
            const checkedAttr = this.isSelected(val.data.id) ? "checked" : "";

            return `<input type="checkbox" 
                 style="cursor: pointer;" 
                 value="${val.data.id}" 
                 ${checkedAttr} 
                 onchange="window.handleCheckboxChange(this.value, this.checked)">`;
          },
        },
        {
          label: "ردیف",
          transform: (val) => {
            const page = this.data?.current_page || 1;
            const perPage = this.data?.per_page || 10;
            let row = page - 1;
            row = row * perPage;
            return row + val.row + 1;
          },
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          transform: (val) => {
            return `<span class="text-primary font-weight-bold">${val.data.id}</span>`;
          },
        },
        {
          label: "رنگ",
          name: "color",
          transform: (val) => {
            const color = val.data.color || "-";
            return `<span class="grey lighten-3 px-2 py-1 rounded">${color}</span>`;
          },
        },
        {
          label: "عنوان",
          name: "title",
          transform: (val) => {
            const title = val.data.title || "--";
            return `
              <span class="px-2 py-1 rounded">
                ${title}
              </span>
            `;
          },
        },
        {
          label: "قیمت",
          name: "price",
          transform: (val) => {
            if (val.data.is_free === 1)
              return `<span class="text-success">رایگان</span>`;
            if (!val.data.price || val.data.price === 0)
              return `<span class="text-success">با هزینه</span>`;
            const price = val.data.price.toLocaleString();
            return `<span class="text-success">${price} ریال</span>`;
          },
        },
        {
          label: "تخفیف",
          name: "discount",
          transform: (val) => `<span>${val.data.discount}%</span>`,
        },
        {
          label: "وضعیت",
          name: "status",
          transform: (val) => {
            const status = val.data.status || "unavailable";
            const qr_id = val.data.order?.qr_id;

            const config = {
              complete: {
                text: "آماده شده",
                icon: "fa-check-double",
                color: "blue lighten-4",
              },
              assigned: {
                text: "اختصاص داده شده به",
                icon: "fa-user-check",
                color: "orange lighten-4",
              },
              available: {
                text: "موجود",
                icon: "fa-check-circle",
                color: "teal lighten-4",
              },
              unavailable: {
                text: "ناموجود",
                icon: "fa-times-circle",
                color: "red lighten-4",
              },
            };

            const current = config[status] || {
              text: status,
              icon: "fa-question",
              color: "grey lighten-3",
            };

            if (status === "assigned") {
              if (qr_id) {
                return `
                  <div class="d-flex align-center justify-center" style="gap: 1px; white-space: nowrap;">
                    <span class="px-1 py-1 rounded ${current.color} shadow-sm d-flex align-center justify-center" style="font-size: 11px; gap: 1px; white-space: nowrap;">
                      <i class="fa ${current.icon} ml-1"></i> ${current.text}
                    <button
                      class="btn btn-outline-info rounded-pill px-1 py-0 d-flex align-center shadow-sm"
                      style="font-size: 11px; height: 26px; border-width: 1px;"
                      onclick="window.copyToClipboard('${qr_id}')"
                    >
                      <span>${qr_id}</span>
                      <i class="fa fa-copy ml-1 text-info"></i>
                    </button>
                    </span>

                  </div>
                `;
              }
              return `<span class="px-2 py-1 rounded ${current.color}"><i class="fa ${current.icon} ml-1"></i> ${current.text}</span>`;
            }

            return `
            <div class="status-badge-wrapper"
             onclick="window.openStatusMenu(event, ${val.data.id})">
              <span class="px-2 py-1 rounded ${current.color} cursor-pointer shadow-sm">
                <i class="fa ${current.icon} ml-1"></i>
                ${current.text}
              </span>
            </div>
            `;
          },
        },

        {
          label: "لینک کوتاه",
          name: "short_link",
          transform: (val) => {
            const link = val.data.short_link || "-";
            if (link === "-") return link;
            return `
              <button class="btn btn-sm btn-outline-primary rounded-pill" onclick="window.copyToClipboard('${link}')">
                ${link}
                <i class="fa fa-copy ml-1"></i>
              </button>
            `;
          },
        },
        {
          label: "آخرین به‌روزرسانی",
          name: "updated_at_p",
        },
        {
          label: "مدیریت",
          name: "action",
          component: manageButton,
          handler: (data, name) => this.actions(data, name),
          event: "actions",
          meta: {
            buttons: [
              {
                name: "edit",
                label: "ویرایش",
                icon: "pencil-ruler",
                status: 'edit_nfc',
                class: "btn-outline-success rounded-lg ma-1",
                action: (data, name) => this.actions(data, name),
                condition: (data) => true,
              },
              {
                name: "fast_write_password_lock",
                label: "نوشتن و قفل با پسورد",
                icon: "key",
                status: 'edit_nfc',
                class: "btn-outline-warning  rounded-lg ma-1",
                action: (data, name) => this.actions(data, name),
                condition: (data) => data.short_link && data.short_link !== "-",  
              },
              {
                name: "fast_write_permanent_lock",
                label: "نوشتن",
                icon: "rss",
                status: 'edit_nfc',
                class: "btn-outline-success  rounded-lg ma-1",
                action: (data, name) => this.actions(data, name),
                condition: (data) => data.short_link && data.short_link !== "-",    
              },
               {
                name: "quick_create_qr",
                icon: "link",
                class: "btn-outline-info  rounded-lg ma-1",
                label: "ساخت Qr و اتصال ",
                status: 'edit_nfc',
                action: (data, name) => this.actions(data, name),
                condition: (data) => data.short_link && data.short_link !== "-" && data.status !== 'assigned'

              }
            ],
          },
        },
      ],
    };
  },
  watch: {
  'editItem.price': function(newPrice) {
    if (newPrice > 0) {
      this.editItem.is_free = 0; 
    } else if (newPrice === 0 || newPrice === "" || newPrice === null) {
      this.editItem.is_free = 1; 
    }
  },

  'editItem.is_free': function(newIsFree) {
    if (newIsFree === 1) {
      this.editItem.price = 0;
    }
  },
  'massUpdateData.price': function(newPrice) {
    if (newPrice > 0) {
      this.massUpdateData.is_free = 0;
    } else if (newPrice === 0 || newPrice === "") {
      this.massUpdateData.is_free = 1;
    }
  },
  'massUpdateData.is_free': function(newIsFree) {
    if (newIsFree === 1) {
      this.massUpdateData.price = 0; 
    } else if (newIsFree === null) {
      this.massUpdateData.price = null;
    }
  }
},
  computed: {
    selectedShort_link() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        return '';
      }      
      const links = this.selectedIds.map(id => {
        const row = this.data.data?.find(item => item.id === id);
        return row && row.short_link ? `https://${row.short_link}` : null;
      }).filter(link => link !== null); 

      if (links.length === 0) return '';

      if (links.length === 1) return links[0];

      return links;
    },
    isAllSelected() {
      if (!this.data || !this.data.data || this.data.data.length === 0)
        return false;
      return this.data.data.every((item) => this.selectedIds.includes(item.id));
    },
    currentItemStatus() {
      const item = this.data.data?.find((i) => i.id === this.statusMenu.id);
      return item?.status;
    },
    parsedIds() {
      if (!this.nfcIdsInput) return [];

      // Split by comma, newline, or Persian comma and filter out empty values
      const ids = this.nfcIdsInput
        .split(/[,\n\r،]+/)
        .map((id) => id.trim())
        .filter((id) => id && !isNaN(Number(id)))
        .map((id) => Number(id));

      return [...new Set(ids)]; // Remove duplicates
    },
  },
  mounted() {
  this.isAutoCycleActive = localStorage.getItem("nfcAutoCycleActive") === "true";
  this.successList = JSON.parse(localStorage.getItem("nfcAutoCycleSuccess") || "[]");

  this.socket = initNfcService({
    onConnect: () => {
      console.log("سوکت به پایتون متصل شد");
      this.isConnected = true;
    },
    onDisconnect: () => {
      console.log("ارتباط سوکت قطع شد");
      this.isConnected = false;
    },
    onNfcUid: (data) => console.log("کارت شناسایی شد", data),
    onReadStatus: (res) => console.log("وضعیت خواندن", res),
    
    // رایت معمولی
    onWriteStatus: (res) => {
      if (res.status === 'success') {
        this.$toast.success("عملیات رایت با موفقیت انجام شد.");
      } else {
        this.$toast.error("خطا در عملیات رایت!");
      }
    }
  });

  this.socket.on('fast_write_result', (response) => {
    if (!this.currentWritingId) return;

    if (response.status === 'success' || response.success) {
      this.$toast.success(response.msg || "رایت فیزیکی موفقیت‌آمیز بود!");
      
      // تغییر وضعیت کارت به "complete" در جدول
      this.toggleNfcStatus(this.currentWritingId, 'complete');

      if (this.isAutoCycleActive) {
        // --- حالت چرخه خودکار فعال ---
        const item = this.data.data?.find(i => i.id === this.currentWritingId);
        this.toggleNfcStatus(this.currentWritingId, 'available');

        if (item) {
          this.$toast.info("در حال ساخت و تخصیص کیوآرکد...");
          this.$refs.assignerComponent.process(item, true);
        } else {
          this.$toast.error("کارت در لیست یافت نشد!");
          this.currentWritingId = null;
        }
      } else {
        this.currentWritingId = null;
      }
      
    } else {
      this.$toast.error(response.msg || "خطا در رایت فیزیکی! لطفاً دوباره تلاش کنید.");
      this.currentWritingId = null; // ریست کردن آیدی
      
      if (this.isAutoCycleActive) {
        setTimeout(() => {
          this.showTuts = true; 
        }, 2000);
      }
    }
  });

  // ۴. دریافت داده‌ها و ثبت توابع سراسری
  this.fetchDesigns();
  window.handleCheckboxChange = (id, isChecked) => {
    this.toggleSelection(Number(id));
  };
  
  this.getData();
  
  window.copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    this.$toast.success("کپی شد.");
  };
  
  window.toggleNfcStatus = this.toggleNfcStatus.bind(this);
  window.openStatusMenu = this.openStatusMenu.bind(this);
  
  // ۵. لیست نوع QR
  this.qrTypesList = [
    { value: "instagram", name: this.$t ? this.$t("filters.qrType.instagram") : "اینستاگرام", icon: "instagram" },
    { value: "visitCard", name: this.$t ? this.$t("filters.qrType.visitCard") : "کارت ویزیت", icon: "card-account-details" },
    { value: "visitcardpro", name: this.$t ? this.$t("filters.qrType.visitCard") : "کارت ویزیت", icon: "card-account-details" },
    { value: "Business", name: this.$t ? this.$t("filters.qrType.Business") : "کسب و کار", icon: "store" },
    { value: "Commericial", name: this.$t ? this.$t("filters.qrType.Commericial") : "تجاری", icon: "office-building" },
    { value: "qrlink", name: this.$t ? this.$t("filters.qrType.qrlink") : "لینک", icon: "link-variant-plus" },
    { name: this.$t ? this.$t("categories.link_pro") : "کلیک یار سئو", value: "clickyarseo", icon: "mdi-link-variant", pro: true },
    { value: "labelproduct", name: this.$t ? this.$t("filters.qrType.labelproduct") : "لیبل محصول", icon: "tag-multiple" },
    { value: "goldLabel", name: this.$t ? this.$t("filters.qrType.goldLabel") : "لیبل طلایی", icon: "gold" },
    { value: "bShop", name: this.$t ? this.$t("filters.qrType.bShop") : "فروشگاه", icon: "storefront" },
    { value: "SocialMedia", name: this.$t ? this.$t("filters.qrType.SocialMedia") : "شبکه اجتماعی", icon: "comment-account" },
    { value: "VideoGallery", name: this.$t ? this.$t("filters.qrType.VideoGallery") : "گالری ویدیو", icon: "video" },
    { value: "PhotoGallery", name: this.$t ? this.$t("filters.qrType.PhotoGallery") : "گالری تصویر", icon: "image" },
    { value: "voiceGallery", name: this.$t ? this.$t("filters.qrType.voiceGallery") : "گالری صوتی", icon: "folder-play" },
    { value: "consultationQr", name: this.$t ? this.$t("filters.qrType.consultationQr") : "مشاوره", icon: "list-box-outline" },
    { value: "application", name: this.$t ? this.$t("filters.qrType.application") : "اپلیکیشن", icon: "application-braces-outline" },
    { value: "feedbackGallery", name: this.$t ? this.$t("filters.qrType.feedbackGallery") : "نظرسنجی", icon: "comment-quote" },
    { value: "voiceGalleryPro", name: this.$t ? this.$t("filters.qrType.voiceGalleryPro") : "گالری صوتی پرو", icon: "folder-play-outline" },
    { value: "singleProduct", name: this.$t ? this.$t("filters.qrType.singleProduct") : "محصول تکی", icon: "package" },
    { value: "menu", name: this.$t ? this.$t("filters.qrType.menu") : "منو", icon: "book-open-outline" },
    { value: "appointment", name: this.$t ? this.$t("filters.qrType.appointment") : "نوبت‌دهی", icon: "calendar-month" },
    { value: "insurance", name: this.$t ? this.$t("filters.qrType.insurance") : "بیمه", icon: "shield-account-outline" },
    { value: "wheel", name: this.$t ? this.$t("filters.qrType.luck_wheel") : "گردونه شانس", icon: "clover-outline" },
    { value: "multicard", name: "مولتی کارت", icon: "card-multiple" },
    { value: "productpro", name: "محصول پرو", icon: "professional-hexagon" },
    { value: "pdfGallery", name: "گالری pdf", icon: "file-pdf-box" },
    { value: "catalog", name: "کاتالوگ", icon: "notebook" },
    { value: "bankcard", name: "کیوکارت", icon: "notebook" },
    { value: "attendanceqr", name: "حضور و غیاب", icon: "account-check" },

  ];

  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect(); 
    }
    if (window.toggleNfcStatus) {
      delete window.toggleNfcStatus;
    }
    if (window.openStatusMenu) {
      delete window.openStatusMenu;
    }
    if (window.copyToClipboard) {
      delete window.copyToClipboard;
    }
  },
  created() {
    this.debouncedReload = debounce((tableProps) => {
      this.getData(tableProps);
    }, 1000);
  },
  methods: {
    async sendDateExpire(qrId, addDay = 100) {
      try {
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + addDay);

        const pad = (n) => String(n).padStart(2, '0');
        const formattedDate = `${targetDate.getFullYear()}-${pad(targetDate.getMonth() + 1)}-${pad(targetDate.getDate())} ${pad(targetDate.getHours())}:${pad(targetDate.getMinutes())}:${pad(targetDate.getSeconds())}`;
        const response = await this.$api.post(`/admin/change-expire/${qrId}`, {
          date: formattedDate 
        });

        this.$toast.success("تاریخ انقضا با موفقیت تغییر یافت.");
        return response;

      } catch (error) {
        console.error("error in change expire date: ", error);
        this.$toast.error("خطا در تغییر تاریخ انقضا.");
      }
    },

     onAssignError(errData) {
    if (errData.isDuplicate) {
      this.duplicateCardsList.push({
        id: errData.item?.id,
        title: errData.item?.title || errData.identifier,
        identifier: errData.identifier,
        time: new Date().toLocaleTimeString("fa-IR"),
      });
      if (this.isAutoActive) {
        setTimeout(() => {
          this.scannerDialog = true;
        }, 500);
      }
      return;
    }
    if (errData.isWriteError) {
      this.pendingWriteItem = errData.item;
      if (this.$toast?.warning) {
        this.$toast.warning("کارت تخصیص نیافت. لطفاً رایت را مجدداً انجام دهید.", { timeout: 7000 });
      }
    }
  },
    triggerAssignerForSuccess(item) {
    if (this.isAutoCycleActive) {
      // ارسال به فرزند برای ساخت QR
      this.$refs.assignerComponent.process(item, true);
      
    } else {
      // حالت دستی
      this.$refs.assignerComponent.process(item, false);
    }
  },

  onAssignSuccess({ item, isAutoCycle }) {
    this.currentWritingId = null; 

    // this.toggleNfcStatus(item.id, 'complete'); 

    if (isAutoCycle) {
      if (!this.successList.includes(item.id)) {
        this.successList.push(item.id);
        localStorage.setItem("nfcAutoCycleSuccess", JSON.stringify(this.successList));
      }

      this.$toast.info("آماده برای اسکن کارت بعدی...");
      
      setTimeout(() => {
        this.showTuts = true; 
      }, 1500);

    } else {
      this.getData();
    }
  },
     toggleAutoCycle() {
      localStorage.setItem("nfcAutoCycleActive", this.isAutoCycleActive);
      if (this.isAutoCycleActive) {
        this.$toast.info("چرخه خودکار فعال شد. لطفاً اولین QR را اسکن کنید.");
        this.showTuts = true; 
      }
    },
    
    clearSuccessList() {
      this.successList = [];
      localStorage.removeItem("nfcAutoCycleSuccess");
      this.$toast.success("لیست موفق‌ها پاک شد.");
    },
    
    copySuccessList() {
      if (this.successList.length === 0) return;
      const textToCopy = this.successList.join('\n');
      navigator.clipboard.writeText(textToCopy);
      this.$toast.success("لیست شناسه‌ها کپی شد.");
    },

    async handleQrCodeData(code) {
      this.filters.search = code;
      this.showTuts = false; 

      if (this.isAutoCycleActive) {
        await this.getData(); 
        
        const item = this.data.data?.find(i => 
          i.id == code || 
          (i.short_link && code.includes(i.short_link))
        );

        if (item) {
          this.fast_write_permanent_lockAction(item);
        } else {
          // this.$toast.error("کارتی با این کیوآرکد در لیست یافت نشد!");
          setTimeout(() => { this.showTuts = true; }, 2000);
        }
      } else {
        if(typeof this.onSearchInput === 'function') {
          this.onSearchInput(); 
        } else {
          this.getData();
        }
      }
    },
    fast_write_permanent_lockAction(item) {
  if (!item || !item.short_link || item.short_link === '-') {
    if (this.$toast) this.$toast.error("لینک معتبری برای رایت وجود ندارد!");
    return;
  }  
  let finalUrl = item.short_link;
  if (!finalUrl.startsWith('http')) {
     finalUrl = 'https://' + finalUrl;
  }  
  this.currentWritingId = item.id;  
  if (this.$toast) this.$toast.info("در حال رایت... لطفاً کارت را به دستگاه نزدیک کنید.");  
  this.socket.emit('nfc-fast-write-permanent-lock', {
    id: item.id,
    url: finalUrl
  });
},

    fastWriteAndLock(item) {
      this.$set(item, 'isWriting', true);

      let finalUrl = item.url || item.code;
      if (finalUrl && !finalUrl.startsWith('http')) {
        finalUrl = 'https://' + finalUrl;
      }
      const password = "111111"; 

      this.socket.emit('fast_write_action', {
        id: item.id,
        url: finalUrl,
        password: password,
        pack: '00 00'
      });
    },
 handleNfcSearch(readUrl) {
    this.filters.search = readUrl.replace(/^https?:\/\//i, '');
      this.onSearchInput();

    },
    openNfcRW(){
      this.nfcRW = !this.nfcRW;
    },
    // handleQrCodeData(data) {
    //   this.filters.search = data; 

    //   this.showTuts = false;      
    //   this.onSearchInput(); 
    // },
    closeMassUpdate() {
      this.showMassUpdateModal = false;
      this.selectedIds = [];
      this.nfcIdsInput = "";
    },
    checkCommonValuesForBulk() {
      const selectedItems = (this.data?.data || []).filter((item) =>
        this.parsedIds.includes(item.id),
      );

      if (selectedItems.length === 0) {
        this.massUpdateToggles = { title: false, image: false, color: false };
        this.bulkRenewalTitle = "";
        this.massUpdateData.color = null;
        this.massUpdateData.front_image = null;
        this.massUpdateData.back_image = null;
        return;
      }

      const getCommonValue = (key) => {
        const firstVal = selectedItems[0][key];
        const isAllSame = selectedItems.every((item) => item[key] === firstVal);
        return isAllSame ? firstVal : null;
      };

      // ---------------- بررسی رنگ (Color) ----------------
      const commonColor = getCommonValue("color");
      if (commonColor) {
        this.massUpdateData.color = commonColor;
        this.massUpdateToggles.color = true;
      } else {
        this.massUpdateData.color = null;
        this.massUpdateToggles.color = false;
      }

      // ---------------- بررسی عنوان (Title) ----------------
      const commonTitle = getCommonValue("title");
      if (commonTitle) {
        this.bulkRenewalTitle = commonTitle;
        this.massUpdateToggles.title = true;
      } else {
        this.bulkRenewalTitle = "";
        this.massUpdateToggles.title = false;
      }

      // ---------------- بررسی تصاویر (Image) ----------------
      const isFrontSame = selectedItems.every(
        (item) => item.front_image === selectedItems[0].front_image,
      );
      const isBackSame = selectedItems.every(
        (item) => item.back_image === selectedItems[0].back_image,
      );
      const isOrientationSame = selectedItems.every(
        (item) => item.orientation === selectedItems[0].orientation,
      );

      if (
        isFrontSame &&
        isBackSame &&
        isOrientationSame &&
        (selectedItems[0].front_image || selectedItems[0].back_image)
      ) {
        this.massUpdateData.front_image = selectedItems[0].front_image;
        this.massUpdateData.back_image = selectedItems[0].back_image;
        this.massUpdateData.orientation =
          selectedItems[0].orientation || "vertical";
        this.massUpdateToggles.image = true;
      } else {
        this.massUpdateData.front_image = null;
        this.massUpdateData.back_image = null;
        this.massUpdateData.orientation = "vertical";
        this.massUpdateToggles.image = false;
      }

      // ---------------- فیلدهای بدون سوییچ (وضعیت و رایگان بودن) ----------------
      const commonStatus = getCommonValue("status");
      if (commonStatus) this.massUpdateData.status = commonStatus;

      const commonIsFree = getCommonValue("is_free");
      if (commonIsFree !== null) this.massUpdateData.is_free = commonIsFree;
    },
    checkCommonValueForBulk() {
      const selectedItems = (this.data?.data || []).filter((item) =>
        this.parsedIds.includes(item.id),
      );
    },
    onTablePropsChanged(props) {
      props.length = this.filters.length;
      this.filters.page = props.page;
      this.tableProps = props;
      this.reloadTable(props);
    },
    openGeneratorPopup() {
      if (this.selectedIds.length === 0) {
        alert("لطفاً ابتدا چند مورد را انتخاب کنید.");
        return;
      }

      this.showGeneratorModal = true;
    },
    async forceDownload(url, fileName) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName || "download.zip";
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("خطا در دانلود فایل:", error);
        window.open(url, "_blank");
      }
    },
    fetchDesigns() {
      this.$api
        .get("/v2/qr-gen/markers")
        .then(({ data }) => {
          const apiData = data.data;
          this.designObject_patttern = Object.keys(apiData.pattern).map(
            (key) => ({ value: key }),
          );
          this.designObject_dots = Object.keys(apiData.markerIn).map((key) => ({
            value: key,
          }));
          this.designObject_square = Object.keys(apiData.markerOut).map(
            (key) => ({ value: key }),
          );
        })
        .catch(() => {});
    },

    generateRandomDesign() {
      const getRandomItem = (arr) => {
        if (!arr || arr.length === 0) return null;
        const randomIndex = Math.floor(Math.random() * arr.length);
        return arr[randomIndex].value;
      };

      const getRandomDarkColor = () => {
        const r = Math.floor(Math.random() * 150)
          .toString(16)
          .padStart(2, "0");
        const g = Math.floor(Math.random() * 150)
          .toString(16)
          .padStart(2, "0");
        const b = Math.floor(Math.random() * 150)
          .toString(16)
          .padStart(2, "0");
        return `#${r}${g}${b}`;
      };

      this.options.dotsOptions.type =
        getRandomItem(this.designObject_patttern) || "rounded";
      this.options.cornersSquareOptions.type =
        getRandomItem(this.designObject_square) || "extra-rounded";
      this.options.cornersDotOptions.type =
        getRandomItem(this.designObject_dots) || "dot";

      this.options.different_borders_color = true;
      this.options.different_eyes_color = true;

      this.options.dotsOptions.color = getRandomDarkColor();
      this.options.marker_out_color = getRandomDarkColor();
      this.options.marker_in_color = getRandomDarkColor();
    },

    getQrDesignParams() {
      return {
        transparent: "on",
        pattern: this.options?.dotsOptions?.type || "ribbon",
        marker_out: this.options?.cornersSquareOptions?.type || "vortex",
        marker_in: this.options?.cornersDotOptions?.type || "ropes",
        marker_out_color: this.options?.different_borders_color
          ? this.options?.marker_out_color
          : this.options?.cornersSquareOptions?.color || "#0000",
        marker_in_color: this.options?.different_eyes_color
          ? this.options?.marker_in_color
          : this.options?.cornersDotOptions?.color || "#0000",
        backcolor: this.options?.dotsOptions?.color || "#fff",
        level: this.options?.qrOptions?.errorCorrectionLevel || "H",
      };
    },
    isSelected(id) {
      return this.selectedIds.includes(id);
    },
    toggleSelectAll(isChecked) {
      if (!this.data || !this.data.data) return;

      if (isChecked) {
        const currentIds = this.data.data.map((item) => item.id);
        const newIds = currentIds.filter(
          (id) => !this.selectedIds.includes(id),
        );
        this.selectedIds.push(...newIds);
      } else {
        const currentIds = this.data.data.map((item) => item.id);
        this.selectedIds = this.selectedIds.filter(
          (id) => !currentIds.includes(id),
        );
        this.selectedIds = [];
      }
    },
    handleQrAction() {
      if (this.downloadUrl) {
        this.downloadUrl = this.downloadUrl.replace("/api/", "/");
        const link = document.createElement("a");
        link.href = this.downloadUrl;
        link.setAttribute("download", "QR-Codes.zip");
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloadUrl = null;
        this.selectedIds = [];
      } else {
        this.sendBulkData();
      }
    },
    sendBulkData() {
      if (!this.ribbon_can("nfc_add_reserve_qr_code")) return;
      if (this.selectedIds.length === 0) {
        this.$toast.warning("لطفاً حداقل یک ردیف را انتخاب کنید.");
        return;
      }
      this.generateRandomDesign();
      const finalQrOptions = this.getQrDesignParams();

      this.$api
        .post("/admin/nfc/gen-image/bulk", {
          ids: this.selectedIds,
          ...finalQrOptions,
        })
        .then((response) => {
          //  this.selectedIds = [];
          this.downloadUrl = response.data;

          this.$toast.success(
            "فایل با موفقیت ساخته شد. حالا روی دکمه دانلود کلیک کنید.",
          );
          // this.reloadTable();
          this.reloadTable(this.filters);
        })
        .catch((error) => {
          console.error("خطای واقعی این است:", error);
          this.$toast.error("خطا در اعمال تغییرات گروهی");
        });
    },
    toggleSelection(id) {
      const index = this.selectedIds.indexOf(id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
      } else {
        this.selectedIds.push(id);
      }
    },
    autoAddMissingConditions() {
      const allTypes = this.apiQrTypesList.map((t) => t.value?.toLowerCase());
      const existingTypes = this.conditionsTableData.data.map((c) =>
        c.type?.toLowerCase(),
      );

      const missingTypes = allTypes.filter((t) => !existingTypes.includes(t));

      if (missingTypes.length === 0) return;
      missingTypes.forEach((typeValue) => {
        const payload = {
          type: typeValue,
          free_permission: 0,
          min_days: 350,
        };

        this.$api
          .post("/admin/nfc/add/type-condition", payload)
          .then(() => {
            console.log("Added auto condition:", typeValue);
          })
          .catch((err) => {
            console.error("Auto add failed:", err);
          });
      });

      setTimeout(() => this.fetchNfcConditions(), 500);
    },
    autoFixAssignedStatuses(items) {
      if (!items || !items.length) return;

      const idsToFix = items
        .filter(
          (item) =>
            item.order && item.order.qr_id && item.status !== "assigned",
        )
        .map((item) => item.id);

      if (idsToFix.length > 0) {
        console.warn("Auto-fixing statuses for IDs:", idsToFix);

        this.$api
          .post("/admin/cart/status_bulk", {
            ids: idsToFix,
            status: "assigned",
          })
          .then(({ data }) => {
            if (data.status) {
              // this.getData();
            }
          })
          .catch((error) => {
            console.error("Error auto-fixing statuses:", error);
          });
      }
    },
    openStatusMenu(event, id) {
      const item = this.data.data?.find((i) => i.id === id);
      if (!item || item.status === "assigned") return;

      this.statusMenu.id = id;
      this.statusMenu.x = event.clientX;
      this.statusMenu.y = event.clientY;
      this.statusMenu.show = true;
    },
    onFilterChange() {
      this.filters.page = 1;
      this.reloadTable();
    },
    onSearchInput() {
      this.filters.page = 1;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.onFilterChange();
      }, 800);
    },

    reloadTable(tableProps) {
      if (tableProps) {
        this.filters.page = tableProps.page || this.filters.page;
        this.filters.length = tableProps.length || this.filters.length;
        this.filters.dir = tableProps.dir || this.filters.dir;
      }

      // this.debouncedReload(this.filters);
      this.getData(this.filters);
    },
    getData(query = this.filters) {
      this.loading = true;
      const requestParams = {
        ...query,
        length: this.filters.length,
        search: this.filters.search,
        status: this.filters.status,
        type: this.filters.type,
        is_free: this.filters.is_free,
      };
      if (requestParams.status === "all" || requestParams.status === null)
        delete requestParams.status;
      if (requestParams.is_free === "all" || requestParams.is_free === null)
        delete requestParams.is_free;
      this.$api
        .get("/admin/index-nfc/cart", { params: requestParams })
        .then((response) => {
          this.data = response.data.data;
          // this.autoFixAssignedStatuses(this.data.data);
        })
        .catch((error) => {
          this.$toast.error("خطا در بارگذاری داده‌ها");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async quick_create_qrAction(item) {
      await this.fast_write_permanent_lockAction(item); 
      try {
        this.$toast.info("در حال تغییر وضعیت کارت و ساخت Qr...");
        this.loading = true; 
        const statusPayload = {
          ids: [item.id],
          status: "available" 
        };
        const statusRes = await this.$api.post("/admin/cart/status_bulk", statusPayload);
        
        if (!statusRes.data.status) {
          throw new Error("خطا در تغییر وضعیت کارت به موجود.");
        }

        const result = await this.$refs.assignerComponent.process(item, false);
        const targetQrId = result?.qrId || result?.qr_id || item?.qrId;
        if (targetQrId) {
          await this.sendDateExpire(targetQrId, 100);
        }
        this.$toast.success(`کیوآر کد با موفقیت ساخته و به کارت ${item.id} متصل شد.`);    
            
        this.getData();

      } catch (error) {
        console.error("خطا در عملیات ساخت سریع:", error);
        
        let errorMsg = "خطا در عملیات ساخت و اتصال.";
        if (error?.response?.data?.message) {
          errorMsg = error.response.data.message;
        } else if (error?.message) {
          errorMsg = error.message;
        }  
        this.$toast.error(errorMsg);
      } finally {
        this.loading = false;
      }
    },

    actions(data, name) {
       if (name === 'quick_create_qr') {
        this.quick_create_qrAction(data);
        return;
      }

      if (name === 'fast_write_permanent_lock') {
    this.fast_write_permanent_lockAction(data);
    return;
      }
      this[name + "Action"](data);
    },
       fast_write_password_lockAction(data) {
      let pwd = "111111"; 
      
      if (pwd && pwd.length === 6) {
        let finalUrl = data.short_link;
        if (finalUrl && !finalUrl.startsWith('http')) {
            finalUrl = "https://" + finalUrl;
        }
        
        // ذخیره آیدی برای تغییر وضعیت بعد از رایت
        this.currentWritingId = data.id; 
        
        this.socket.emit("fast_write_action", {
          id: data.id,
          url: finalUrl,
          password: pwd, 
          pack: "00 00" 
        });
        
        if (this.$toast) this.$toast.info("درخواست رایت و قفل پسوردی به سخت‌افزار ارسال شد...");
      } else if (pwd) {
          this.$toast.warning("پسورد کارت‌ها باید دقیقاً 6 کاراکتر باشد.");
      }
    },

  
    editAction(item) {
      this.editItem = {
        id: item.id,
        title: item.title,
        price: this.english(item.price|| 0)||0,
        discount: item.discount || 0,
        tags: item.tags,
        front_image: item.front_image,
        back_image: item.back_image,
        orientation: item.orientation || "vertical",
        color: item.color,
        status: item.status || "unavailable",
        short_link: item.short_link,
        is_free: item.is_free || 0,
      };
      this.showEditModal = true;
      if (this.$refs.editForm) {
        this.$refs.editForm.resetValidation();
      }
    },
    saveChanges() {
      if (!this.$refs.editForm.validate()) {
        return;
      }

      this.saving = true;

      const payload = {
        title: this.editItem.title,
        price: this.english(this.editItem.price),
        discount: this.editItem.discount,
        tags: this.editItem.tags,
        front_image: this.editItem.front_image,
        back_image: this.editItem.back_image,
        orientation: this.editItem.orientation,
        color: this.editItem.color,
        status: this.editItem.status,
        short_link: this.editItem.short_link,
        is_free: this.editItem.is_free,
      };

      this.$api
        .post(`/admin/nfc/update/${this.editItem.id}`, payload)
        .then(({ data }) => {
          this.saving = false;
          if (data.status) {
            this.$toast.success("کارت با موفقیت ویرایش شد.");
            this.showEditModal = false;
            this.getData();
          } else {
            this.$toast.error(data.message || "خطا در ویرایش کارت");
          }
        })
        .catch((error) => {
          this.saving = false;
          this.$toast.error("خطا در ویرایش کارت");
          console.error(error);
        });
    },
    openNFCFreeModal() {
      this.nfcConditionView = "list";
      this.showNfcFreeModal = true;
      this.fetchNfcConditions();
      this.autoAddMissingConditions();
      this.apiQrTypesList = this.getQrTypes();
    },

    fetchNfcConditions() {
      this.conditionsLoading = true;
      this.$api
        .get("/admin/nfc/type-condition")
        .then(({ data }) => {
          if (Array.isArray(data.data)) {
            this.conditionsTableData = {
              data: data.data,
              current_page: 1,
              last_page: 1,
              total: data?.data?.length || 100,
            };
          } else {
            this.conditionsTableData = data.data || { data: data };
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.conditionsLoading = false;
        });
    },

    getQrIcon(typeValue) {
      const types = this.getQrTypes();
      const found = types.find(
        (q) => q.value?.toLowerCase() === typeValue?.toLowerCase(),
      );
      return found ? `mdi-${found.icon}` : "mdi-qrcode";
    },
    getQrName(typeValue) {
      const types = this.getQrTypes();
      const found = types.find(
        (q) => q.value?.toLowerCase() === typeValue?.toLowerCase(),
      );
      return found ? found.name : typeValue;
    },
    goToAddCondition() {
      this.nfcFreeData = {
        isEdit: false,
        id: null,
        type: null,
        free_permission: 1,
        min_days: 350,
      };
      this.nfcConditionView = "form";
      if (this.$refs.nfcFreeForm) this.$refs.nfcFreeForm.resetValidation();
    },
    async deleteCondition(item) {
      if (
        await this.$modal.yesNo("آیا از حذف شرایط طرح رایگان NFC مطمئن هستید؟")
      ) {
        this.saving = true;
        this.$api
          .delete("/admin/nfc/delete/type-condition", {
            data: { type: item.type },
          })
          .then(() => {
            this.$nextTick(() => {
              this.$toast.success("تنظیمات مورد نظر با موفقیت حذف شد.");
              this.nfcConditionView = "list";
              this.fetchNfcConditions();
              this.saving = false;
            });
          })
          .finally(() => (this.saving = false));
      }
    },
    editCondition(item) {
      this.nfcFreeData = {
        isEdit: true,
        id: item.id,
        type: item.type,
        free_permission:
          item.free_permission === true || item.free_permission == 1 ? 1 : 0,
        min_days: item.min_days || 350,
      };
      this.nfcConditionView = "form";
    },

    // 6. ثبت یا ویرایش
    saveNFCFree() {
      if (!this.$refs.nfcFreeForm.validate()) return;
      this.saving = true;

      const payload = {
        type: this.nfcFreeData.type,
        free_permission: this.nfcFreeData.free_permission,
        min_days: this.nfcFreeData.min_days,
      };

      const url = "/admin/nfc/add/type-condition";

      this.$api
        .post(url, payload)
        .then(({ data }) => {
          this.$toast.success("تنظیمات با موفقیت ثبت شد.");
          this.nfcConditionView = "list";
          this.fetchNfcConditions();
        })
        .catch((error) => {
          this.$toast.error("خطا در ثبت اطلاعات");
          console.error(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    openMassUpdateModal() {
      this.nfcIdsInput =
        this.selectedIds.length > 0 ? this.selectedIds.join(",") : "";

      this.massUpdateData = {
        status: "unavailable",
        is_free: null,
        price: null,
        discount: null,
        front_image: null,
        back_image: null,
        orientation: "vertical",
        color: null,
      };
      if (this.$refs.massUpdateForm) {
        this.$refs.massUpdateForm.resetValidation();
      }
      this.checkCommonValuesForBulk();
      if (this.massUpdateData.front_image) {
        const preloadFront = new Image();
        preloadFront.src = this.massUpdateData.front_image;
      }

      if (this.massUpdateData.back_image) {
        const preloadBack = new Image();
        preloadBack.src = this.massUpdateData.back_image;
      }
      this.showMassUpdateModal = true;
    },
    saveMassUpdate() {
      if (
        !this.$refs.massUpdateForm.validate() ||
        this.parsedIds.length === 0
      ) {
        return;
      }
      const hasAnyChange =
        this.massUpdateData.is_free !== null ||
        this.massUpdateData.price !== null ||
        this.massUpdateData.discount !== null ||
        (this.massUpdateToggles.title && this.massUpdateData.title !== null) ||
        (this.massUpdateToggles.color && this.massUpdateData.color !== null) ||
        (this.massUpdateToggles.image &&
          (this.massUpdateData.front_image !== null ||
            this.massUpdateData.back_image !== null ||
            this.massUpdateData.orientation !== null));

      if (!hasAnyChange) {
        this.$toast.warning("لطفاً حداقل یک وضعیت را برای تغییر انتخاب کنید.");
        return;
      }
      this.saving = true;

      const payload = {
        ids: this.parsedIds,
        status: this.massUpdateData.status,
        is_free: this.massUpdateData.is_free,
        price:
          this.massUpdateData.is_free === 0
            ? this.massUpdateData.price || 0
            : null,
        discount:
          this.massUpdateData.is_free === 0
            ? this.massUpdateData.discount || 0
            : null,
        title:
          this.massUpdateToggles.title === true ? this.bulkRenewalTitle : null,
        front_image:
          this.massUpdateToggles.image === true
            ? this.massUpdateData.front_image
            : null,
        back_image:
          this.massUpdateToggles.image === true
            ? this.massUpdateData.back_image
            : null,
        orientation:
          this.massUpdateToggles.image === true
            ? this.massUpdateData.orientation
            : null,
        color:
          this.massUpdateToggles.color === true
            ? this.massUpdateData.color
            : null,
      };

      this.$api
        .post("/admin/cart/status_bulk", payload)
        .then(({ data }) => {
          this.saving = false;
          if (data.status) {
            this.$toast.success(
              `تغییر وضعیت با موفقیت انجام شد. ${
                data.updated_count || this.parsedIds.length
              } کارت ویرایش شد.`,
            );
            this.showMassUpdateModal = false;
            this.selectedIds = [];
            this.nfcIdsInput = "";

            this.getData();
          } else {
            this.$toast.error(data.message || "خطا در تغییر وضعیت گروهی");
          }
        })
        .catch((error) => {
          this.saving = false;
          this.$toast.error("خطا در تغییر وضعیت گروهی");
          console.error(error);
        });
    },
    toJalaliDateTime(gregorianDate) {
      try {
        return moment(gregorianDate)
          .locale("fa")
          .format("jYYYY/jMM/jDD HH:mm:ss");
      } catch (error) {
        console.error("Error converting date:", error);
        return "-";
      }
    },
    confirmStatusChange(newStatus) {
      if (!this.selectedIdForStatus) return;

      this.loading = true;
      this.statusMenuModal = false;

      this.$api
        .post(`/admin/cart/status_bulk`, {
          ids: [this.selectedIdForStatus],
          status: newStatus,
        })
        .then(({ data }) => {
          if (data.status) {
            this.$toast.success("وضعیت با موفقیت تغییر کرد.");
            this.getData();
          } else {
            this.$toast.error(data.message || "خطا در تغییر وضعیت");
          }
        })
        .catch((error) => {
          this.$toast.error("خطا در ارتباط با سرور");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.selectedIdForStatus = null;
        });
    },
    toggleNfcStatus(id, newStatus) {
      const item = this.data.data?.find((item) => item.id === id);
      if (!item || item.status === "assigned" || item?.order !== null) return;
      this.loading = true;
      this.$api
        .post(`/admin/cart/status_bulk`, { ids: [id], status: newStatus })
        .then(({ data }) => {
          if (data.status) {
            this.$toast.success("وضعیت کارت با موفقیت تغییر کرد.");
            this.getData();
            this.statusMenuModal = false;
          } else {
            this.$toast.error(data.message || "خطا در تغییر وضعیت");
          }
        })
        .catch((error) => {
          this.$toast.error("خطا در تغییر وضعیت");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.statusMenu.show = false;
        });
    },
  },
};
</script>

<style scoped>
.preview-img {
  max-width: 250px;
  max-height: 350px;
  object-fit: contain;
  border: 2px solid #e0e0e0;
}

.edit-preview-img {
  max-width: 200px;
  max-height: 280px;
  object-fit: contain;
  border: 2px solid #e0e0e0;
}

/* Vuetify color classes for HTML elements */
.grey {
  background-color: #9e9e9e !important;
}

.grey.lighten-3 {
  background-color: #f5f5f5 !important;
  color: #424242 !important;
}

.blue {
  background-color: #2196f3 !important;
}

.blue.lighten-4 {
  background-color: #bbdefb !important;
  color: #0d47a1 !important;
}

.purple {
  background-color: #9c27b0 !important;
}

.purple.lighten-4 {
  background-color: #e1bee7 !important;
  color: #4a148c !important;
}

.teal {
  background-color: #009688 !important;
}

.teal.lighten-4 {
  background-color: #b2dfdb !important;
  color: #00695c !important;
}

.red {
  background-color: #f44336 !important;
}

.red.lighten-4 {
  background-color: #ffcdd2 !important;
  color: #c62828 !important;
}

.rounded {
  border-radius: 4px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.text-success {
  color: #4caf50 !important;
}

.text-primary {
  color: #1976d2 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-pointer:hover {
  opacity: 0.7;
  text-decoration: underline !important;
}
</style>
